import React, { useState, useEffect, useRef } from 'react'
import { COLORES } from '../../../../config/colores'
import { IconButton, Button, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CamposPesoConRemito from './CamposPesoConRemito'
import { DialogConfirmacionContent } from '../../../Dialogos/DialogConfirmacionContent'

function PesadoConRemitoPeso (props) {
  const { handleSubmit, reset, pesadoAuto, pesoBruto, deleteRemito } = props
  const [open, setOpen] = useState(false)

  const disabled = pesoBruto === '' || isNaN(pesoBruto)

  const fieldRef = useRef(null)

  useEffect(() => {
    if (fieldRef.current && fieldRef.current.focus) {
      fieldRef.current.focus()
    }
  }, [fieldRef])

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpenConfirmacion = () => {
    setOpen(true)
  }

  const handleKeyDown = (e, index) => {
    console.log(e.key)
    if (e.key === 'Enter' || e.key === 'A' || e.key === 'a') {
      handleSubmit()
    } else if (e.key === 'x' || e.key === 'X' || e.key === 'R' || e.key === 'r') {
      handleOpenConfirmacion()
    }
  }

  const eliminarRemito = () => {
    console.log('elimino remito ? ')
    deleteRemito()
    setOpen(false)
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='sm'
      >
        <DialogView
          confirmCallback={eliminarRemito}
          cancelCallback={handleClose}
          title='Eliminar remito'
          content={<DialogConfirmacionContent
            message='¿Está seguro que quiere eliminar este remito?'
          />
          }
        />
      </Dialog>

      <div className='container-campos-form'>
        <div style={{ margin: 'auto' }} className='campos-remito'>
          <IconButton onClick={reset} style={{ outlined: 'none' }}>
            <ArrowBackIcon style={{ color: COLORES.grey.medium }} />
          </IconButton>

          <CamposPesoConRemito
            style={{ margin: '2%', width: '95%' }}
            pesadoAuto={pesadoAuto}
          />
        </div>

        <div
          className='btn-remito'
          style={{ border: 'none', outline: 'none' }}
          tabIndex={0}
          onKeyDown={handleKeyDown}
          ref={fieldRef}
        >
          <Button
            size='medium'
            style={{ backgroundColor: COLORES.red.medium, width: '100%', marginTop: '3%', color: '#ffffff' }}
            variant='contained'
            onClick={handleOpenConfirmacion}
          >
                                Cancelar
          </Button>

          <Button
            size='medium'
            style={{ backgroundColor: !disabled ? COLORES.green.medium : COLORES.grey.light, width: '100%', marginTop: '3%', color: '#ffffff' }}
            variant='contained'
            type='submit'
            onClick={handleSubmit}
            disabled={disabled}
          >
                                Guardar
          </Button>
        </div>
      </div>
    </>

  )
}

export default PesadoConRemitoPeso
